import { useCallback } from "react";
import styled from "styled-components";
import { Button, Label } from "@sablier/v2-components/molecules";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useDurationForm } from "~/client/hooks";

const Wrapper = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    flex: 1;
    row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
    width: 100%;
  }
`;

const Actions = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    flex-wrap: wrap;
    grid-gap: calc(${(props) => props.theme.sizes.edge} * 0.5);
    width: 100%;
  }
`;

type Suggestion = {
  title: string;
  purpose?: "years" | "days" | "hours";
  value: number;
};

function Suggested() {
  const { t } = useT();
  const suggested: Suggestion[] = [
    {
      title: `2 ${t("words.years")}`,
      purpose: "years",
      value: 2,
    },
    {
      title: `1 ${t("words.year")}`,
      purpose: "years",
      value: 1,
    },
    {
      title: `180 ${t("words.days")}`,
      purpose: "days",
      value: 180,
    },
    {
      title: `30 ${t("words.days")}`,
      purpose: "days",
      value: 30,
    },
    {
      title: `7 ${t("words.days")}`,
      purpose: "days",
      value: 7,
    },
    {
      title: `2 ${t("words.days")}`,
      purpose: "days",
      value: 2,
    },
    {
      title: `1 ${t("words.day")}`,
      purpose: "days",
      value: 1,
    },
  ];

  const update = useDurationForm((state) => state.api.updateFields);

  const onSuggest = useCallback(
    (action: Suggestion) => {
      update({
        years: { value: undefined },
        days: { value: undefined },
        hours: { value: undefined },
        [(action.purpose as string) || "days"]: {
          value: action.value,
        },
      });
    },
    [update],
  );
  return (
    <Wrapper>
      <Label value={_.capitalize(t("words.suggested"))} />
      <Actions>
        {suggested.map((action) => (
          <Button
            key={action.title}
            accent={"dark400"}
            appearance={"outline"}
            onClick={() => onSuggest(action)}
            isMini
            title={action.title}
          />
        ))}
      </Actions>
    </Wrapper>
  );
}

export default Suggested;
